import {
  Field,
  useFormContext,
  Widget,
  type ValidationItems,
} from '@kanda-libs/ks-component-ts';
import { useCallback, useMemo } from 'react';

const ViewComponent = () => {
  const { getValues, setValue } = useFormContext();
  const postcodeName = 'job.customer.address.postcode';

  const postcodeValidation = useMemo(
    (): ValidationItems => ({
      required: { value: true, message: 'Postcode is required.' },
      pattern: {
        value:
          /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/,
        message: 'Postcode input is invalid',
      },
    }),
    [],
  );

  const onPostcodeBlur = useCallback(() => {
    const postcode = getValues(postcodeName) as string | undefined;
    if (!postcode) return;
    const clean = postcode.toUpperCase().replace(/\s+/g, '');
    const postcodeRegex =
      /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/;
    if (!postcodeRegex.test(clean)) {
      return;
    }
    const formatted = [clean.slice(0, -3), clean.slice(-3)].join(' ');
    setValue(postcodeName, formatted);
  }, [getValues, setValue, postcodeName]);

  return (
    <div className="flex flex-col">
      <div className="border-b border-neutral-300 mt-1 mb-4" />
      <span className="text-16-24-em text-neutral-900">Customer Address</span>
      <div className="mt-3" />
      <Widget.JobCustomerAddressLine1 placeholder="Address line 1" />
      <div className="mt-3" />
      <Widget.JobCustomerAddressLine2 placeholder="Address line 2 (optional)" />
      <div className="mt-3" />
      <Widget.JobCustomerAddressCity placeholder="Address city" />
      <div className="mt-3" />
      <Widget.JobCustomerAddressCounty placeholder="Address county (optional)" />
      <div className="mt-3" />
      <Widget.JobCustomerAddressCountry placeholder="Address country" />
      <div className="mt-3" />
      <Field.Validator validation={postcodeValidation}>
        <Field.Input
          name={postcodeName}
          placeholder="Address postcode"
          onBlur={onPostcodeBlur}
        />
      </Field.Validator>
    </div>
  );
};

ViewComponent.displayName = 'CreateJob-Desktop-Customer-Field-Address-view';

export default ViewComponent;
